// extracted by mini-css-extract-plugin
module.exports = {"avatar":"HostImage_avatar__2lpRj"};